import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Tender, TenderItem } from 'lib/types/models';

export type Business = {
  id: string | null;
  name: string | null;
  identifier?: string | null;
};

export type TenderWithItemsAndBuyer = Tender & {
  items: (TenderItem & { supplier: Business | null })[];
  buyer: Business;
};

export type TenderModalState = {
  open: boolean;
  tender: TenderWithItemsAndBuyer | null;
};

const initialState: TenderModalState = {
  open: false,
  tender: null,
};

const tenderModalSlice = createSlice({
  name: 'tenderModal',
  initialState,
  reducers: {
    showTenderModal: (
      state,
      action: PayloadAction<TenderWithItemsAndBuyer>,
    ) => {
      state.open = true;
      state.tender = action.payload;
    },
    hideTenderModal: (state) => {
      state.open = false;
      state.tender = null;
    },
  },
});

export const { showTenderModal, hideTenderModal } = tenderModalSlice.actions;
export default tenderModalSlice.reducer;
